// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_input__ane12 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/data/inputCheckRadio/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AACF","sourcesContent":[".input {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `styles_input__ane12`
};
export default ___CSS_LOADER_EXPORT___;
